import { Layers3, Server, Wrench, CalendarCheck, Package, BadgeCheck } from "lucide-react";

const ICONS = { abonnement: Package, hebergement: Server, total: BadgeCheck, installation: Wrench, entretien: CalendarCheck };

export const isSolution = (p) => Boolean(p?.solution_level);

export function SolutionLevelBadge({ level, className = "" }) {
  if (!level) return null;
  return <span className={`inline-flex items-center gap-1 rounded-full border border-[#7DC4E8] bg-[#0369A1] px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white ${className}`} data-testid="solution-level-badge"><Layers3 size={11} /> Niveau {level}</span>;
}

export function SolutionModules({ modules = [] }) {
  if (!modules.length) return null;
  return (
    <div className="mt-6 rounded-2xl border border-[#7DC4E8] bg-[#E0F2FE] p-5" data-testid="solution-modules">
      <p className="font-mono text-xs uppercase tracking-widest text-[#0369A1]">Modules inclus ({modules.length})</p>
      <ul className="mt-3 flex flex-wrap gap-2">{modules.map((m) => <li key={m} className="rounded-full border border-[#7DC4E8] bg-white px-3 py-1 text-xs font-medium text-[#0C4A6E]">{m}</li>)}</ul>
    </div>
  );
}

export function SolutionPricing({ rows = [] }) {
  if (!rows.length) return null;
  return (
    <div className="mt-6 overflow-hidden rounded-2xl border border-[#7DC4E8] bg-white" data-testid="solution-pricing">
      <div className="border-b border-[#7DC4E8] bg-[#E0F2FE] px-5 py-3"><p className="font-mono text-xs uppercase tracking-widest text-[#0369A1]">Tableau tarifaire indicatif</p></div>
      <table className="w-full text-sm">
        <tbody>
          {rows.map((r) => { const Icon = ICONS[r.key] || Package; const total = r.key === "total"; return (
            <tr key={r.key} className={`border-b border-[#BAE0F5] last:border-0 ${total ? "bg-[#F0F9FF] font-semibold" : ""}`} data-testid={`solution-price-${r.key}`}>
              <td className="flex items-center gap-2 px-5 py-3 text-[#0C4A6E]"><Icon size={15} className="text-[#0369A1]" /> {r.label}</td>
              <td className="px-5 py-3 text-right font-display text-[#0369A1]">{r.affichage} <span className="text-[11px] font-normal text-slate-500">{r.unite.replace("FCFA", "").trim()}</span></td>
            </tr>
          ); })}
        </tbody>
      </table>
      <p className="px-5 py-3 text-[11px] text-slate-500">Tarifs indicatifs hors taxes, ajustés selon le périmètre, le nombre de sites et d'utilisateurs. Demandez un devis personnalisé.</p>
    </div>
  );
}
